<template>
  <div :class="[this.uniqueItemListContainerKey, 'dt-page']">
    <v-layout row wrap>
      <div row wrap :class="[ `${this.config.itemKey}-ltb`, 'ldt-top-bar']">
        <div class="add-button">
          <img @click="onAddItemClick" class="dt-icon" src="static/buttons/add.svg" alt />
        </div>
        <div class="search">
          <InputField
            :value="searchString"
            :placeholder="'Search'"
            :config="{
                  borderStyle: 'around'
              }"
            @keyup="onSearchInputKeyup"
          ></InputField>
        </div>

        <div class="right-space"></div>
      </div>
    </v-layout>
    <v-layout row wrap>
      <v-flex md12 pa-1>
        <div :class="[this.itemListContainerKey]">
          <slot #itemList ></slot>
        </div>
      </v-flex>
    </v-layout>
    <v-navigation-drawer v-bind="defaultConfig" :value="contactDetailsFlag" touchless>
      <slot #itemSidewindow></slot>
    </v-navigation-drawer>
  </div>
</template>

<script>
import InputField from "@plugins/text-field/input-field";


export default {
  components: {
    InputField,
  },
  data: function() {
    return {
      searchString: ''
    };
  },
  props: {
    config: {
      type: Object,
      default: () => ({
        itemKey: 'item'
      })
    },
    sidewindowConfig: {
      required: true,
      type: Object
    }
  },
  computed: {
    itemListKey: function() {
      return `${this.config.itemKey}-list`;
    },
    itemListContainerKey: function() {
      return `${this.config.itemKey}-list-container`;
    },
    uniqueItemListContainerKey: function() {
      return `cmp-${this.config.itemKey}-list-container`;
    },
  },
  methods: {
    onAddItemClick: function() {
      this.$emit('onAddItemClick', true);
    },
    onSearchInputKeyup: function(event) {
      console.log(event);
    }
    //MARK: Methods
  }
}
</script>

<style>

</style>
